'use strict';
import _ from 'lodash';

// Delimiter character to use
const DELIM_CHAR = ':';

export default {
	/**
	 * Encodes 'type' and 'value' to GraphQL base64 string.
	 *
	 * @param {String} type
	 * @param {Number} value
	 * @returns {String}
	 */
	encodeId: (type, value) => {
		return window.btoa(type + DELIM_CHAR + value);
	},

	/**
	 * Decodes an encodedId to a 'type' and 'value'
	 *
	 * @param encodedValue
	 * @returns {Object}
	 * @property {String} type
	 * @property {Number} value
	 */
	decodeId: encodedValue => {
		const result = window.atob(encodedValue);
		const splitCharIndex = result.indexOf(DELIM_CHAR);

		if (splitCharIndex < 0) {
			return null;
		}

		return {
			type: result.substring(0, splitCharIndex),
			value: result.substring(splitCharIndex + 1),
		};
	},

	/**
	 * Removes the `__typename` property from a given object to resolve mutation errors
	 *
	 * @param obj
	 * @returns {Object}
	 */
	removeTypename: obj => {
		if (_.isObject(obj) && !_.isEmpty(obj)) {
			return JSON.parse(JSON.stringify(obj), (key, value) =>
				key === '__typename' ? undefined : value,
			);
		}

		return obj;
	},
};



// WEBPACK FOOTER //
// ./src/assets/js/lib/graphql-lib.js